import { createContext, useContext } from 'react';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getStorage } from "firebase/storage";

interface FirebaseContextType {
  app: FirebaseApp;
  storage: ReturnType<typeof getStorage>;
}

export const FirebaseContext = createContext<FirebaseContextType | null>(null);

export const useFirebase = () => {
  const firebase = useContext(FirebaseContext);
  if (!firebase) {
    throw new Error(
      'useFirebase must be used within a FirebaseProvider. ' +
      'Did you forget to wrap your app with FirebaseProvider?'
    );
  }
  return firebase;
};

const firebaseConfigProduction = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: "soundness-9ae94.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const firebaseConfigStaging = {
  apiKey: process.env.REACT_APP_STAGING_API_KEY,
  authDomain: process.env.REACT_APP_STAGING_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_STAGING_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STAGING_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_STAGING_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_STAGING_APP_ID,
};

// TODO: revert this once we have launched the site fully, currently we are using the production config for staging
// and will make production a site without data/ event listsing.
// const firebaseConfig = process.env.REACT_APP_ENVIRONMENT === 'production' ? firebaseConfigProduction : firebaseConfigStaging;
const firebaseConfig = firebaseConfigProduction;

const firebaseApp = initializeApp(firebaseConfig);

const firebaseStorage = getStorage(firebaseApp);

export const FirebaseProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <FirebaseContext.Provider value={{ app: firebaseApp, storage: firebaseStorage }}>
      {children}
    </FirebaseContext.Provider>
  );
}; 